// extracted by mini-css-extract-plugin
export default {"container":"StatusLabel_container__5oqov"};